import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const ContentBlocks = () => {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/content/blocks").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  const decide = async (id, decision) => { try { await api.post(`/admin/content/blocks/${id}/decide`, { decision }); toast.success("Decision sent to the member"); load(); } catch (e) { toast.error(errMsg(e)); } };
  if (!d) return null;
  return (
    <section className="space-y-3" data-testid="admin-content-blocks">
      <h2 className="text-2xl">AI-blocked content</h2>
      <p className="text-xs text-slate-500">Everything posted is checked by AI first. Members can ask for a human review; requests show first.</p>
      {d.blocks.length === 0 ? <p className="text-sm text-slate-500">Nothing blocked yet.</p> : (
        <ul className="space-y-2">{[...d.blocks].sort((a, b) => (b.review?.state === "requested") - (a.review?.state === "requested")).map((b) => (
          <li key={b.id} className="surface space-y-1 p-3 text-sm" data-testid={`block-${b.id}`}>
            <p className="text-xs text-slate-500">{b.kind} · {fmtDate(b.at)} · {b.categories.join(", ")} · ref {b.id.slice(0, 8)}{b.review && <b className="ml-1 text-amber-700"> · review {b.review.state}</b>}</p>
            <p className="text-slate-800">“{b.text.slice(0, 280)}”</p><p className="text-xs text-rose-700">{b.reason}</p>
            {b.review?.state === "requested" && <div className="flex gap-2"><Button size="sm" className="rounded-full" onClick={() => decide(b.id, "overturned")} data-testid={`block-overturn-${b.id}`}>Allow it</Button>
              <Button size="sm" variant="outline" className="rounded-full" onClick={() => decide(b.id, "upheld")} data-testid={`block-uphold-${b.id}`}>Keep blocked</Button></div>}
          </li>))}</ul>)}
    </section>
  );
};
